'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function loadScript(scriptUrl, data = {}, attributes = {}) {
  const script = document.createElement("script");
  script.async = true;
  Object.entries(data).forEach(([attribute, value]) => {
    script.dataset[attribute] = value;
  });
  Object.entries(attributes).forEach(([attribute, value]) => {
    script.setAttribute(attribute, value);
  });
  return new Promise((resolve, reject) => {
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
    script.src = scriptUrl;
    document.head.appendChild(script);
  });
}

exports.loadScript = loadScript;
